import { useMemo } from 'react'
import { AccessibleCalendar } from '../ui/calendar'

interface SessionCalendarProps {
  isOpen: boolean
  onClose: () => void
  availableDates: string[]
  selectedDate: string
  onSelectDate: (date: string) => void
  returnFocusRef?: React.RefObject<HTMLElement | null>
}

/**
 * Calendar for picking a logged training session. Wraps the accessible
 * calendar primitive and disables days without sessions.
 */
export function SessionCalendar({
  isOpen,
  onClose,
  availableDates,
  selectedDate,
  onSelectDate,
  returnFocusRef,
}: SessionCalendarProps) {
  const availableSet = useMemo(() => new Set(availableDates), [availableDates])

  return (
    <AccessibleCalendar
      isOpen={isOpen}
      onClose={onClose}
      selectedDate={selectedDate}
      onSelectDate={onSelectDate}
      availableDates={availableSet}
      disableUnavailable
      title="Pick a session"
      helper="Amber dot = logged session"
      returnFocusRef={returnFocusRef}
    />
  )
}
